export default __webpack_public_path__ + "assets/5685c45d1a0d0a6a1e833698cff72749.png";